import { Layout } from "@shopify/polaris";

function Loading() {
	return (
		<Layout>
			<p>Pulling images from NASA...</p>
		</Layout>
	);
}

export default Loading;
